// Curated 2026 dates from India_2026_Important_Days_Master_Calendar.xlsx, MASTER 2026.
// Fields: date, name, category, audience, date confidence, priority, verification URL.
const master2026 = [
  [
    "2026-01-01",
    "Gaan-Ngai (Zeliangrong festival)",
    "Indigenous / Regional",
    "Manipur",
    "2026 state calendar",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-01-01",
    "New Year's Day",
    "Cultural",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-04",
    "World Braille Day",
    "International / Inclusion",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-01-05",
    "Guru Gobind Singh Ji Gurpurab",
    "Sikh",
    "Punjab / Sikh communities",
    "Community calendar—verify",
    "RECHECK",
    "https://sgpc.net/"
  ],
  [
    "2026-01-09",
    "Pravasi Bharatiya Divas",
    "Civic / Diaspora",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-10",
    "Torgya festival begins (Tawang)",
    "Buddhist / Regional",
    "Arunachal Pradesh",
    "10–12 January, local programme",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-01-10",
    "World Hindi Day",
    "Education / Language",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.unesco.org/en/days"
  ],
  [
    "2026-01-11",
    "Missionary Day",
    "Regional / Christian",
    "Mizoram",
    "Fixed",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-01-12",
    "National Youth Day / Swami Vivekananda Jayanti",
    "Education / Youth",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-13",
    "Lohri",
    "Regional / Sikh / Hindu",
    "Punjab / Haryana / Delhi / Himachal Pradesh",
    "Fixed",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-01-13",
    "Maghi / Mela Maghi",
    "Sikh / Regional",
    "Punjab",
    "Regional calendar—verify",
    "RECHECK",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-01-14",
    "Bhogi",
    "Hindu / Harvest",
    "Andhra Pradesh / Telangana / Tamil Nadu",
    "Regional calendar—verify",
    "RECHECK",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-01-14",
    "Makar Sankranti / Uttarayan",
    "Hindu / Harvest",
    "North / West / Central India",
    "Fixed solar date",
    "MEDIUM",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-01-15",
    "Indian Army Day",
    "Defence",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-15",
    "Magh Bihu / Bhogali Bihu",
    "Regional / Harvest",
    "Assam",
    "State observance",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-01-15",
    "Pongal / Thai Pongal",
    "Hindu / Harvest",
    "Tamil Nadu / Puducherry",
    "State observance",
    "MEDIUM",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-01-16",
    "Joonbeel Mela window",
    "Indigenous / Heritage",
    "Assam",
    "Mid-January; local programme verify",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-01-16",
    "Kanuma",
    "Harvest / Regional",
    "Andhra Pradesh / Telangana",
    "Regional",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-01-16",
    "Thiruvalluvar Day",
    "Language / Regional",
    "Tamil Nadu / Puducherry",
    "Fixed state observance",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-01-17",
    "Uzhavar Thirunal",
    "Harvest",
    "Tamil Nadu",
    "Regional",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-19",
    "Kokborok Day",
    "Language / Regional",
    "Tripura",
    "Fixed",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-01-19",
    "Sonam Losar",
    "Buddhist / Regional",
    "Sikkim / Himalayan communities",
    "Regional calendar—verify",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-01-21",
    "Manipur Statehood Day",
    "State Formation",
    "Manipur",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-21",
    "Meghalaya Statehood Day",
    "State Formation",
    "Meghalaya",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-21",
    "Tripura Statehood Day",
    "State Formation",
    "Tripura",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-23",
    "Netaji Subhas Chandra Bose Jayanti / Parakram Diwas",
    "Freedom / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-23",
    "Vasant Panchami / Saraswati Puja",
    "Hindu / Education",
    "North / East India",
    "Central restricted holiday",
    "HIGH",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-01-24",
    "International Day of Education",
    "International / Education",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-01-24",
    "National Girl Child Day",
    "Education / Women",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-24",
    "Uttar Pradesh Foundation Day",
    "State Formation",
    "Uttar Pradesh",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-25",
    "Himachal Pradesh Statehood Day",
    "State Formation",
    "Himachal Pradesh",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-25",
    "National Tourism Day (India)",
    "Tourism",
    "All India",
    "Widely observed; official use varies",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-25",
    "National Voters' Day",
    "Constitution / Electoral",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-25",
    "World Leprosy Day",
    "Medical",
    "All India",
    "Last Sunday Jan 2026",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-01-26",
    "International Day of Clean Energy",
    "International / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-01-26",
    "Republic Day",
    "National / Constitution",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-01-27",
    "International Holocaust Remembrance Day",
    "International / History",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-01-28",
    "Data Privacy Day",
    "Technology / Awareness",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-30",
    "Martyrs' Day (Mahatma Gandhi)",
    "Freedom / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-01-30",
    "World Neglected Tropical Diseases Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-02-01",
    "Guru Ravidas Jayanti",
    "Religious / Social",
    "Punjab / Haryana / UP / Sikh and Ravidassia communities",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-02-01",
    "Reh Festival begins",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "1–6 February annual",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-02-01",
    "Thaipusam",
    "Hindu / Tamil",
    "Tamil Nadu / Kerala / Puducherry",
    "Regional panchang",
    "MEDIUM",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-02-02",
    "World Wetlands Day",
    "International / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-02-04",
    "International Day of Human Fraternity",
    "International / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-02-04",
    "World Cancer Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-02-06",
    "International Day of Zero Tolerance for FGM",
    "International / Health",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-02-07",
    "ICC Men's T20 World Cup begins (India & Sri Lanka)",
    "Sports / 2026 Tournament",
    "India / Sri Lanka",
    "ICC confirmed 7 Feb–8 Mar",
    "HIGH",
    "https://www.icc-cricket.com/news/fixtures-groups-released-for-icc-men-s-t20-world-cup-2026"
  ],
  [
    "2026-02-09",
    "International Epilepsy Day",
    "Medical",
    "All India",
    "Second Monday February 2026",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-02-10",
    "World Pulses Day",
    "International / Agriculture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-02-11",
    "International Day of Women and Girls in Science",
    "Education / STEM",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-12",
    "Maharishi Dayanand Saraswati Jayanti",
    "Religious / Reform",
    "All India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-02-13",
    "World Radio Day",
    "Media",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-14",
    "Valentine's Day",
    "Cultural",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-15",
    "Lui-Ngai-Ni",
    "Regional / Tribal",
    "Manipur",
    "State observance",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-02-15",
    "Maha Shivaratri",
    "Hindu",
    "All India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-02-15",
    "Tamladu Festival",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "Fixed",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-02-18",
    "Losar (Tibetan New Year)",
    "Buddhist / Regional",
    "Ladakh / Sikkim / Arunachal Pradesh",
    "Regional calendar—verify",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-02-18",
    "Ramadan begins (estimated)",
    "Islam",
    "Muslim communities / All India",
    "Moon sighting—confirm locally",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-19",
    "Chhatrapati Shivaji Maharaj Jayanti",
    "History / Regional",
    "Maharashtra",
    "Fixed",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-02-20",
    "Arunachal Pradesh Statehood Day",
    "State Formation",
    "Arunachal Pradesh",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-20",
    "Mizoram Statehood Day",
    "State Formation",
    "Mizoram",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-20",
    "World Day of Social Justice",
    "International / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-02-21",
    "International Mother Language Day",
    "Education / Language",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-21",
    "World Tourist Guide Day",
    "Tourism",
    "All India",
    "Widely observed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-24",
    "Central Excise Day",
    "Civic / Economy",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-25",
    "Sekrenyi Festival begins",
    "Indigenous / Regional",
    "Nagaland",
    "Traditional Feb–March",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-02-26",
    "Nyokum Yullo",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "Fixed tradition",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-02-28",
    "National Science Day",
    "Education / Science",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-02-28",
    "Rare Disease Day",
    "Medical",
    "All India",
    "Last day February",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-01",
    "Zero Discrimination Day",
    "International / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-03-03",
    "Dol Jatra / Dol Purnima",
    "Hindu / Bengali",
    "West Bengal / Odisha / Assam",
    "Regional panchang",
    "MEDIUM",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-03-03",
    "Holika Dahan / Chhoti Holi",
    "Hindu",
    "North India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-03-03",
    "World Hearing Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-03",
    "World Wildlife Day",
    "Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-03",
    "Yaoshang begins",
    "Regional / Hindu",
    "Manipur",
    "Regional calendar",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-03-04",
    "Hola Mohalla begins (Anandpur Sahib)",
    "Sikh / Regional",
    "Punjab",
    "Approx 4–6 March; verify SGPC",
    "RECHECK",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-03-04",
    "Holi / Dhulandi",
    "Hindu",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-03-04",
    "World Obesity Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-08",
    "ICC Men's T20 World Cup final",
    "Sports / 2026 Tournament",
    "India",
    "ICC announced",
    "HIGH",
    "https://www.icc-cricket.com/news/fixtures-groups-released-for-icc-men-s-t20-world-cup-2026"
  ],
  [
    "2026-03-08",
    "International Women's Day",
    "International / Women",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-03-09",
    "Chapchar Kut (Mizoram celebrations)",
    "Regional / Tribal",
    "Mizoram",
    "Local schedule—verify",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-03-12",
    "World Kidney Day",
    "Medical",
    "All India",
    "Second Thursday March 2026",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-13",
    "Chapchar Kut (alternate state holiday)",
    "Regional / Tribal",
    "Mizoram",
    "Published calendars differ; verify local Govt",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-03-15",
    "World Consumer Rights Day",
    "International / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-03-16",
    "National Vaccination Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-17",
    "Shab-e-Qadr (regional holiday estimate)",
    "Islam",
    "Jammu & Kashmir and Muslim communities",
    "Moon-sighting dependent",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-19",
    "Chaitra Navratri begins",
    "Hindu",
    "All India",
    "Panchang—regional variation",
    "MEDIUM",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-03-19",
    "Cheti Chand / Sindhi New Year",
    "Sindhi / Hindu",
    "Sindhi communities / India",
    "Central restricted date",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-03-19",
    "Ugadi / Gudi Padwa / Chaitra Shukladi",
    "Hindu / New Year",
    "Andhra Pradesh / Telangana / Karnataka / Maharashtra / Goa",
    "Central restricted date; local calendars may differ",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-03-20",
    "International Day of Happiness",
    "International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-03-20",
    "Jumat-ul-Vida",
    "Islam",
    "All India",
    "Moon-sighting dependent",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-20",
    "Myoko Festival begins",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "20–23 March local programme",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-03-20",
    "World Oral Health Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-21",
    "Eid-ul-Fitr / Ramzan Id",
    "Islam",
    "All India",
    "Central gazetted; moon sighting",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-03-21",
    "International Day of Forests",
    "International / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-03-21",
    "Naw-Ruz (Bahá'í New Year)",
    "Bahá'í",
    "Bahá'í communities / All India",
    "Community calendar—verify sunset timing",
    "RECHECK",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-21",
    "World Down Syndrome Day",
    "Medical / Inclusion",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-21",
    "World Poetry Day",
    "International / Arts",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-03-22",
    "Bihar Diwas",
    "State Formation",
    "Bihar",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-22",
    "World Water Day",
    "International / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-03-23",
    "Shaheed Diwas (Bhagat Singh, Rajguru, Sukhdev)",
    "Freedom",
    "All India / Punjab",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-23",
    "World Meteorological Day",
    "Science / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-24",
    "World Tuberculosis Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-03-26",
    "Ram Navami",
    "Hindu",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-03-27",
    "World Theatre Day",
    "Arts / Culture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-30",
    "Rajasthan Day",
    "State Formation",
    "Rajasthan",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-03-31",
    "Mahavir Jayanti",
    "Jain",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-04-01",
    "Aoleang Festival begins",
    "Indigenous / Regional",
    "Nagaland",
    "1–6 April",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-04-01",
    "April Fools' Day",
    "Popular Culture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-01",
    "Odisha Foundation Day / Utkal Divas",
    "State Formation",
    "Odisha",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-02",
    "International Children's Book Day",
    "Education / Literature",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-02",
    "World Autism Awareness Day",
    "Medical / Inclusion",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-03",
    "Good Friday",
    "Christian",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-04-04",
    "International Day for Mine Awareness",
    "International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-04-05",
    "Easter Sunday",
    "Christian",
    "All India",
    "2026 church calendar",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-05",
    "Mopin",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "Fixed tradition",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-04-05",
    "National Maritime Day",
    "Civic / Maritime",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-06",
    "International Day of Sport for Development and Peace",
    "Sports",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-07",
    "World Health Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-10",
    "World Homeopathy Day",
    "Medical / Professional",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-11",
    "National Safe Motherhood Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-13",
    "Jallianwala Bagh Remembrance",
    "Freedom / History",
    "Punjab / All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-14",
    "Ambedkar Jayanti",
    "Constitution / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-14",
    "Baisakhi / Vaisakhi / Khalsa Sajna Divas",
    "Sikh / Harvest",
    "Punjab / Haryana / All India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-04-14",
    "Biju Festival begins",
    "Indigenous / Regional",
    "Tripura",
    "Regional",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-04-14",
    "Bohag Bihu / Rongali Bihu begins",
    "Regional / Harvest",
    "Assam",
    "Regional multiday",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-04-14",
    "Puthandu / Tamil New Year",
    "Hindu / Tamil",
    "Tamil Nadu / Puducherry",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-04-14",
    "Sangken / Water Festival begins",
    "Buddhist / Regional",
    "Arunachal Pradesh",
    "14–16 April",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-04-14",
    "Vishu",
    "Hindu / Kerala",
    "Kerala",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-04-14",
    "Vishu Kani / regional Vishu events",
    "Hindu / Regional",
    "Kerala",
    "Solar date",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-04-15",
    "Himachal Day",
    "State Formation",
    "Himachal Pradesh",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-15",
    "Poila Boishakh / Bengali New Year",
    "Regional / New Year",
    "West Bengal / Tripura",
    "Solar new year",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-04-17",
    "World Hemophilia Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-18",
    "World Heritage Day",
    "International / Heritage",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-04-19",
    "World Liver Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-21",
    "Civil Services Day (India)",
    "Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-21",
    "Ridván begins (Bahá'í)",
    "Bahá'í",
    "Bahá'í communities / All India",
    "21 April–2 May; verify community",
    "RECHECK",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-21",
    "World Creativity and Innovation Day",
    "International / Arts",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-04-22",
    "Earth Day",
    "International / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-04-23",
    "World Book and Copyright Day",
    "Education / Literature",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.unesco.org/en/days"
  ],
  [
    "2026-04-24",
    "National Panchayati Raj Day",
    "Constitution / Governance",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-04-24",
    "World Immunization Week begins",
    "Medical",
    "All India",
    "24–30 April",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-25",
    "World Malaria Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-04-26",
    "World Intellectual Property Day",
    "International / Innovation",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-04-28",
    "World Day for Safety and Health at Work",
    "International / Labour",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-04-29",
    "International Dance Day",
    "Arts / Culture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-01",
    "Buddha Purnima / Vesak",
    "Buddhist",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-05-01",
    "Gujarat Day",
    "State Formation",
    "Gujarat",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-01",
    "International Workers' Day / May Day",
    "Labour",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-01",
    "Maharashtra Day",
    "State Formation",
    "Maharashtra",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-01",
    "Moatsü Festival begins",
    "Indigenous / Regional",
    "Nagaland",
    "Regional",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-05-03",
    "Lai Haraoba seasonal celebrations",
    "Indigenous / Regional",
    "Manipur",
    "Village-specific April–June; exact date unconfirmed",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-05-03",
    "World Press Freedom Day",
    "Media",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-05",
    "World Hand Hygiene Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-05-08",
    "World Red Cross and Red Crescent Day",
    "Medical / Humanitarian",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-05-08",
    "World Thalassaemia Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-05-09",
    "Rabindranath Tagore Jayanti",
    "Arts / History",
    "West Bengal / All India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-05-10",
    "Mother's Day",
    "Cultural / Family",
    "All India",
    "Second Sunday May 2026",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-11",
    "National Technology Day",
    "Science / Technology",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-12",
    "International Nurses Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-05-15",
    "International Day of Families",
    "International / Family",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-05-16",
    "Sikkim Statehood Day",
    "State Formation",
    "Sikkim",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-17",
    "World Telecommunication and Information Society Day",
    "Technology",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-18",
    "International Museum Day",
    "Arts / Heritage",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-19",
    "World Family Doctor Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-05-21",
    "National Anti-Terrorism Day (India)",
    "Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-21",
    "World Day for Cultural Diversity",
    "International / Culture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-05-22",
    "International Day for Biological Diversity",
    "Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-23",
    "International Day to End Obstetric Fistula",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-05-27",
    "Eid-ul-Adha / Bakrid",
    "Islam",
    "All India",
    "Central gazetted; moon sighting",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-05-28",
    "International Day of Action for Women's Health",
    "Medical / Women",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-05-30",
    "Goa Statehood Day",
    "State Formation",
    "Goa",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-05-31",
    "Saga Dawa celebrations",
    "Buddhist / Regional",
    "Sikkim",
    "Lunar calendar—verify",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-05-31",
    "World No Tobacco Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-06-01",
    "Global Day of Parents",
    "International / Family",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-02",
    "Telangana Formation Day",
    "State Formation",
    "Telangana",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-06-03",
    "World Bicycle Day",
    "International / Sport",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-05",
    "World Environment Day",
    "International / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-07",
    "World Food Safety Day",
    "Medical / Food",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-06-08",
    "World Oceans Day",
    "International / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-11",
    "FIFA World Cup begins",
    "Sports / 2026 Tournament",
    "International / India fan interest",
    "FIFA confirmed",
    "HIGH",
    "https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/fifa-world-cup-26-match-schedule-revealed"
  ],
  [
    "2026-06-12",
    "World Day Against Child Labour",
    "International / Children",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-14",
    "World Blood Donor Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-06-15",
    "World Elder Abuse Awareness Day",
    "International / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-16",
    "Guru Arjan Dev Ji Shaheedi Diwas",
    "Sikh",
    "Punjab / Sikh communities",
    "Community calendar—verify",
    "RECHECK",
    "https://sgpc.net/"
  ],
  [
    "2026-06-18",
    "Autistic Pride Day",
    "Medical / Inclusion",
    "All India",
    "Community observance",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-06-19",
    "World Sickle Cell Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-06-20",
    "World Refugee Day",
    "International / Humanitarian",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-21",
    "Father's Day",
    "Cultural / Family",
    "All India",
    "Third Sunday June 2026",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-06-21",
    "International Day of Yoga",
    "International / Wellness",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-21",
    "International Day of the Celebration of the Solstice",
    "International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-06-22",
    "Ambubachi Mela begins",
    "Hindu / Regional",
    "Assam",
    "Traditional 22–26 June; confirm Temple",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-06-23",
    "International Olympic Day",
    "Sports",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-06-23",
    "UN Public Service Day",
    "Governance",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-06-26",
    "International Day Against Drug Abuse and Illicit Trafficking",
    "Medical / Social",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-06-26",
    "Muharram / Ashura",
    "Islam",
    "All India",
    "Central gazetted; moon sighting",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-06-27",
    "MSME Day",
    "Economy / Business",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-06-29",
    "National Statistics Day",
    "Science / Governance",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-01",
    "Chartered Accountants' Day",
    "Professional",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-01",
    "GST Day",
    "Economy / Governance",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-01",
    "National Doctors' Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-07-01",
    "National Postal Worker Day",
    "Professional",
    "All India",
    "Widely observed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-05",
    "Dree Festival",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "Annual 5–7 July",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-07-06",
    "World Zoonoses Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-07-07",
    "World Chocolate Day",
    "Popular Culture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-11",
    "World Population Day",
    "International / Population",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-07-12",
    "Behdienkhlam (traditional July window)",
    "Indigenous / Regional",
    "Meghalaya",
    "Exact 2026 dates local—verify",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-07-15",
    "World Youth Skills Day",
    "International / Education",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-07-16",
    "Kang Chingba (Manipur Rath Yatra)",
    "Hindu / Regional",
    "Manipur",
    "16–24 July regional programme",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-07-16",
    "Rath Yatra / Jagannath Puri",
    "Hindu / Regional",
    "Odisha / Gujarat / All India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-07-17",
    "World Day for International Justice",
    "International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-07-18",
    "Nelson Mandela International Day",
    "International / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-07-18",
    "Tamil Nadu Day",
    "State Formation",
    "Tamil Nadu",
    "Fixed state observance",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-19",
    "FIFA World Cup final",
    "Sports / 2026 Tournament",
    "International / India fan interest",
    "FIFA confirmed",
    "HIGH",
    "https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/fifa-world-cup-26-match-schedule-revealed"
  ],
  [
    "2026-07-20",
    "International Chess Day",
    "Sports",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-22",
    "Pi Approximation Day",
    "Science / Education",
    "All India",
    "Widely observed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-24",
    "Kharchi Puja window",
    "Regional / Indigenous",
    "Tripura",
    "Traditional July; verify royal temple",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-07-25",
    "World Drowning Prevention Day",
    "Medical / Safety",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-07-26",
    "Kargil Vijay Diwas",
    "Defence",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-28",
    "World Hepatitis Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-07-28",
    "World Nature Conservation Day",
    "Environment",
    "All India",
    "Widely observed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-29",
    "International Tiger Day",
    "Environment / Wildlife",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-07-29",
    "ORS Day (India)",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-07-30",
    "International Day of Friendship",
    "International / Family",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-07-30",
    "World Day Against Trafficking in Persons",
    "International / Human Rights",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-08-01",
    "National Mountain Climbing Day",
    "Sports / Outdoor",
    "All India",
    "Popular observance",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-01",
    "World Breastfeeding Week begins",
    "Medical",
    "All India",
    "1–7 August",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-08-02",
    "Friendship Day (India)",
    "Cultural / Family",
    "All India",
    "First Sunday August",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-06",
    "Hiroshima Day",
    "International / History",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-08-07",
    "National Handloom Day",
    "Arts / Textile",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-08",
    "Quit India Movement Anniversary",
    "Freedom",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-09",
    "International Day of the World's Indigenous Peoples",
    "International / Indigenous",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-08-09",
    "Nagasaki Day",
    "International / History",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-08-10",
    "World Biofuel Day",
    "Energy / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-12",
    "International Youth Day",
    "International / Youth",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-08-12",
    "World Elephant Day",
    "Environment / Wildlife",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-13",
    "International Left-Handers Day",
    "Social / Education",
    "All India",
    "Widely observed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-14",
    "Partition Horrors Remembrance Day",
    "Freedom / History",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-15",
    "Hariyali Teej / Teeyan",
    "Hindu / Regional",
    "Rajasthan / Punjab / Haryana / UP",
    "Panchang 2026",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-08-15",
    "Independence Day",
    "National / Freedom",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-08-15",
    "Parsi New Year / Shahenshahi Navroz",
    "Zoroastrian / Parsi",
    "Maharashtra / Gujarat / Parsi communities",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-08-17",
    "Nag Panchami",
    "Hindu",
    "North / Central / West India",
    "Panchang—verify local timing",
    "RECHECK",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-08-19",
    "World Humanitarian Day",
    "International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-08-19",
    "World Photography Day",
    "Arts / Media",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-20",
    "Sadbhavana Diwas",
    "Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-20",
    "World Mosquito Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-08-23",
    "National Space Day (India)",
    "Science / Space",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-26",
    "Milad-un-Nabi",
    "Islam",
    "All India",
    "Central gazetted; moon sighting",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-08-26",
    "Onam / Thiruvonam",
    "Hindu / Regional / Harvest",
    "Kerala / Malayali communities",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-08-27",
    "Pang Lhabsol",
    "Buddhist / Regional",
    "Sikkim",
    "Lunar local calendar—verify",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-08-28",
    "Raksha Bandhan",
    "Hindu / Cultural",
    "North / West / Central India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-08-29",
    "National Sports Day / Major Dhyan Chand Jayanti",
    "Sports",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-30",
    "Small Industry Day (India)",
    "Economy / Business",
    "All India",
    "Widely observed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-08-31",
    "Kajari Teej",
    "Hindu / Regional",
    "UP / Rajasthan / Madhya Pradesh",
    "Panchang 2026",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-09-01",
    "National Nutrition Week begins",
    "Medical / Nutrition",
    "All India",
    "1–7 September",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-09-01",
    "Solung Festival",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "1–5 September annual",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-09-01",
    "Solung Festival begins",
    "Indigenous / Regional",
    "Arunachal Pradesh",
    "Annual 1–5 Sep",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-09-02",
    "World Coconut Day",
    "Agriculture / Regional",
    "All India / Kerala",
    "Fixed",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-09-04",
    "Janmashtami / Krishna Janmashtami",
    "Hindu",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-09-05",
    "International Day of Charity",
    "International / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-05",
    "Teachers' Day (India)",
    "Education",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-09-07",
    "International Day of Clean Air for Blue Skies",
    "Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-09-08",
    "International Literacy Day",
    "International / Education",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-08",
    "Paryushan begins (Shvetambara)",
    "Jain",
    "Jain communities / All India",
    "Community-based: verify local sangh",
    "RECHECK",
    "https://jain.nidarshanavedh.com/jain-festivals-2026/"
  ],
  [
    "2026-09-09",
    "International Day to Protect Education from Attack",
    "International / Education",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-10",
    "World Suicide Prevention Day",
    "Medical / Mental Health",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-09-14",
    "Ganesh Chaturthi",
    "Hindu",
    "Maharashtra / Goa / Karnataka / All India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-09-14",
    "Hartalika Teej",
    "Hindu / Regional",
    "Maharashtra / Bihar / UP / Jharkhand",
    "Panchang 2026",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-09-14",
    "Hindi Diwas",
    "Education / Language",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-09-15",
    "Engineers' Day (India)",
    "STEM / Professional",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-09-15",
    "International Day of Democracy",
    "International / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-15",
    "Samvatsari (Shvetambara)",
    "Jain",
    "Jain communities",
    "Community-based: verify local sangh",
    "RECHECK",
    "https://jain.nidarshanavedh.com/jain-festivals-2026/"
  ],
  [
    "2026-09-16",
    "Das Lakshan Parva begins (Digambara Jain)",
    "Jain",
    "Jain communities",
    "Community-based",
    "MEDIUM",
    "https://jain.nidarshanavedh.com/jain-festivals-2026/"
  ],
  [
    "2026-09-16",
    "International Day for the Preservation of the Ozone Layer",
    "Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-09-17",
    "World Patient Safety Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-09-18",
    "International Equal Pay Day",
    "International / Labour",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-19",
    "Asian Games Aichi–Nagoya begins",
    "Sports / 2026 Tournament",
    "International / Indian contingent",
    "Ministry of Sports confirmed",
    "HIGH",
    "https://yas.gov.in/en/sports/participation-indian-contingent-20th-asian-games-2026-scheduled-be-held-19th-september-4th"
  ],
  [
    "2026-09-21",
    "International Day of Peace",
    "International / Peace",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-21",
    "World Alzheimer's Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-09-23",
    "International Day of Sign Languages",
    "International / Inclusion",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-23",
    "Vamana Jayanti",
    "Hindu",
    "All India",
    "Regional panchang",
    "MEDIUM",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-09-24",
    "Ziro Festival of Music begins",
    "Arts / Music",
    "Arunachal Pradesh",
    "24–27 September programme",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-09-25",
    "Anant Chaturdashi / Ganesh Visarjan",
    "Hindu",
    "Maharashtra / All India",
    "Regional panchang",
    "MEDIUM",
    "https://www.drikpanchang.com/calendars/indian/indiancalendar.html"
  ],
  [
    "2026-09-26",
    "World Environmental Health Day",
    "Environment / Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-09-27",
    "Kshamavani (Digambara Jain)",
    "Jain",
    "Jain communities",
    "Community-based: verify local sangh",
    "RECHECK",
    "https://jain.nidarshanavedh.com/jain-festivals-2026/"
  ],
  [
    "2026-09-27",
    "World Tourism Day",
    "International / Tourism",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-28",
    "International Day for Universal Access to Information",
    "Media / Information",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-09-28",
    "World Rabies Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-09-29",
    "International Day of Awareness of Food Loss and Waste",
    "International / Agriculture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-09-29",
    "World Heart Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-09-30",
    "International Translation Day",
    "Language / International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-01",
    "International Day of Older Persons",
    "International / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-01",
    "National Voluntary Blood Donation Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-10-02",
    "Gandhi Jayanti / International Day of Non-Violence",
    "National / Freedom",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-10-02",
    "Lal Bahadur Shastri Jayanti",
    "National / History",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-04",
    "Asian Games Aichi–Nagoya concludes",
    "Sports / 2026 Tournament",
    "International / Indian contingent",
    "Ministry of Sports confirmed",
    "HIGH",
    "https://yas.gov.in/en/sports/participation-indian-contingent-20th-asian-games-2026-scheduled-be-held-19th-september-4th"
  ],
  [
    "2026-10-04",
    "World Animal Day",
    "Environment / Wildlife",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-05",
    "World Habitat Day",
    "International / Urban",
    "All India",
    "First Monday October 2026",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-05",
    "World Teachers' Day",
    "International / Education",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-06",
    "International Geodiversity Day",
    "Science / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-08",
    "Indian Air Force Day",
    "Defence",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-09",
    "World Post Day",
    "International / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-10",
    "World Mental Health Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-10-11",
    "International Day of the Girl Child",
    "International / Children",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-12",
    "World Arthritis Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-10-13",
    "International Day for Disaster Risk Reduction",
    "Safety / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-15",
    "Global Handwashing Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-10-15",
    "International Day of Rural Women",
    "International / Women",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-16",
    "World Anaesthesia Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-10-16",
    "World Food Day",
    "International / Food",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-17",
    "International Day for the Eradication of Poverty",
    "International / Economy",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-17",
    "International Day of Intangible Cultural Heritage",
    "Arts / Heritage",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-18",
    "Durga Puja Saptami",
    "Hindu / Bengali",
    "West Bengal / Assam / Tripura",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-10-19",
    "Durga Ashtami / Mahashtami",
    "Hindu",
    "West Bengal / North India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-10-20",
    "Dussehra / Vijayadashami",
    "Hindu",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-10-21",
    "Police Commemoration Day",
    "Civic / Defence",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-24",
    "United Nations Day",
    "International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-10-24",
    "World Polio Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-10-26",
    "Maharishi Valmiki Jayanti",
    "Religious / Literature",
    "North India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-10-27",
    "World Day for Audiovisual Heritage",
    "Arts / Media",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-29",
    "Karwa Chauth",
    "Hindu",
    "North India / Punjab / Haryana",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-10-29",
    "World Stroke Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-10-30",
    "Lungzubel Festival",
    "Regional / Culture",
    "Assam / Dima Hasao",
    "Local 2026 organiser date",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-10-31",
    "National Unity Day / Sardar Vallabhbhai Patel Jayanti",
    "National / History",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-10-31",
    "World Cities Day",
    "International / Urban",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-11-01",
    "Andhra Pradesh Formation Day",
    "State Formation",
    "Andhra Pradesh",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-01",
    "Chhattisgarh Foundation Day",
    "State Formation",
    "Chhattisgarh",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-01",
    "Haryana Day",
    "State Formation",
    "Haryana",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-01",
    "Karnataka Rajyotsava",
    "State Formation",
    "Karnataka",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-01",
    "Kerala Piravi",
    "State Formation",
    "Kerala",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-01",
    "Madhya Pradesh Foundation Day",
    "State Formation",
    "Madhya Pradesh",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-01",
    "Puducherry Liberation Day",
    "State / UT History",
    "Puducherry",
    "Local observance",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-01",
    "Punjab Day (1966 reorganisation anniversary)",
    "State Formation",
    "Punjab",
    "Fixed historical date",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-05",
    "World Tsunami Awareness Day",
    "Environment / Safety",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-07",
    "National Cancer Awareness Day (India)",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-11-08",
    "Bandi Chhor Divas",
    "Sikh",
    "Punjab / Sikh communities",
    "Linked to Diwali; community calendar",
    "MEDIUM",
    "https://sgpc.net/"
  ],
  [
    "2026-11-08",
    "Diwali / Deepavali",
    "Hindu",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-11-08",
    "Mahavir Nirvana / Jain Diwali",
    "Jain",
    "Jain communities",
    "Community calendar",
    "MEDIUM",
    "https://jain.nidarshanavedh.com/jain-festivals-2026/"
  ],
  [
    "2026-11-09",
    "Govardhan Puja / Annakut",
    "Hindu",
    "North / West India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-11-09",
    "Jain New Year",
    "Jain",
    "Jain communities",
    "Community calendar",
    "MEDIUM",
    "https://jain.nidarshanavedh.com/jain-festivals-2026/"
  ],
  [
    "2026-11-09",
    "Uttarakhand Foundation Day",
    "State Formation",
    "Uttarakhand",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-10",
    "World Science Day for Peace and Development",
    "International / Science",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-11-11",
    "Bhai Dooj",
    "Hindu",
    "North / West India",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-11-11",
    "National Education Day / Maulana Abul Kalam Azad Jayanti",
    "Education",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-12",
    "Wangala Festival begins",
    "Indigenous / Regional",
    "Meghalaya",
    "12–14 November event programme",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-11-12",
    "World Pneumonia Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-11-14",
    "Children's Day / Jawaharlal Nehru Jayanti",
    "National / Education",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-14",
    "World Diabetes Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-11-15",
    "Chhath Puja",
    "Hindu / Regional",
    "Bihar / Jharkhand / eastern Uttar Pradesh",
    "Central restricted holiday",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-11-15",
    "Janjatiya Gaurav Divas",
    "Indigenous / National",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-11-15",
    "Jharkhand Foundation Day / Birsa Munda Jayanti",
    "State Formation / Indigenous",
    "Jharkhand / All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-15",
    "Nongkrem Dance Festival (November window)",
    "Indigenous / Regional",
    "Meghalaya",
    "Date to confirm with organisers",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-11-15",
    "World Prematurity Day",
    "Medical",
    "All India",
    "WHO 2026 listed date",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-11-16",
    "International Day for Tolerance",
    "International / Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-11-17",
    "National Epilepsy Day (India)",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-11-17",
    "World Cervical Cancer Elimination Day",
    "Medical",
    "All India",
    "WHO 2026 listed date",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-11-18",
    "World AMR Awareness Week begins",
    "Medical",
    "All India",
    "18–24 November",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-11-19",
    "International Men's Day",
    "Social",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-19",
    "World Toilet Day",
    "International / Sanitation",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-11-20",
    "Shillong Cherry Blossom Festival begins",
    "Arts / Tourism",
    "Meghalaya",
    "20–21 November programme",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-20",
    "World Children's Day",
    "International / Children",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-11-21",
    "Jatinga Festival begins",
    "Regional / Tourism",
    "Assam / Dima Hasao",
    "21–22 November event",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-11-21",
    "Manipur Sangai Festival (November window)",
    "Regional / Tourism",
    "Manipur",
    "Tentative 21–30 November; official notice needed",
    "RECHECK",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-11-21",
    "World Television Day",
    "Media",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-24",
    "Guru Nanak Dev Ji Jayanti",
    "Sikh",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-11-24",
    "Guru Tegh Bahadur Ji Shaheedi Diwas",
    "Sikh",
    "Punjab / Sikh communities",
    "Central restricted calendar; community may vary",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-11-25",
    "International Day for Elimination of Violence Against Women",
    "International / Women",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-11-26",
    "Constitution Day / Samvidhan Divas",
    "Constitution / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-26",
    "National Milk Day (India)",
    "Agriculture / Nutrition",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-11-28",
    "Maihadi Festival begins",
    "Regional / Tourism",
    "Assam / Dima Hasao",
    "28–29 November event",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-11-29",
    "International Day of Solidarity with Palestinian People",
    "International / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-01",
    "Hornbill Festival begins (1–10 December)",
    "Regional / Tourism",
    "Nagaland",
    "Annual window",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-12-01",
    "Nagaland Statehood Day",
    "State Formation",
    "Nagaland",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-01",
    "World AIDS Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-12-02",
    "Assam Divas / Sukapha Divas",
    "State History",
    "Assam",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-02",
    "National Pollution Control Day",
    "Environment / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-03",
    "International Day of Persons with Disabilities",
    "International / Inclusion",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-04",
    "Indian Navy Day",
    "Defence",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-05",
    "International Volunteer Day",
    "International / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-05",
    "World Soil Day",
    "Environment / Agriculture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-07",
    "Armed Forces Flag Day",
    "Defence",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-07",
    "International Civil Aviation Day",
    "International / Aviation",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-08",
    "Bodhi Day",
    "Buddhist",
    "Buddhist communities",
    "Community observance",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-09",
    "International Anti-Corruption Day",
    "Civic / International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-10",
    "Human Rights Day",
    "International / Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-11",
    "Falcon Festival begins",
    "Regional / Tourism",
    "Assam / Dima Hasao",
    "11–13 December event",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-12-11",
    "International Mountain Day",
    "Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-12",
    "Universal Health Coverage Day",
    "Medical",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.who.int/india/campaigns"
  ],
  [
    "2026-12-14",
    "National Energy Conservation Day",
    "Energy / Environment",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-16",
    "Vijay Diwas",
    "Defence / History",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-18",
    "International Migrants Day",
    "International / Diaspora",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-18",
    "Minorities Rights Day (India)",
    "Civic / Inclusion",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-19",
    "Goa Liberation Day",
    "Freedom / Regional",
    "Goa / All India",
    "Fixed",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-12-19",
    "Judima Festival begins",
    "Regional / Tourism",
    "Assam / Dima Hasao",
    "19–21 December event",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-12-20",
    "International Human Solidarity Day",
    "International",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.un.org/en/observances/list-days-weeks"
  ],
  [
    "2026-12-20",
    "Losoong / Namsoong (winter window)",
    "Buddhist / Indigenous",
    "Sikkim",
    "Traditional December; local calendar",
    "MEDIUM",
    "https://northeastindiafestivals.com/festival-dates-2026"
  ],
  [
    "2026-12-22",
    "National Mathematics Day / Srinivasa Ramanujan Jayanti",
    "Education / Maths",
    "All India",
    "Fixed",
    "HIGH",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-23",
    "Hazrat Ali Birthday (restricted calendar date)",
    "Islam",
    "Muslim communities",
    "Moon-sighting dependent",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-23",
    "Kisan Diwas / National Farmers' Day",
    "Agriculture",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-24",
    "Christmas Eve",
    "Christian",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-24",
    "Kuki Christmas Eve observances",
    "Christian / Regional",
    "North-East India",
    "Community programmes vary",
    "MEDIUM",
    "https://publicholidays.in/"
  ],
  [
    "2026-12-24",
    "National Consumer Day",
    "Civic / Consumer",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-25",
    "Christmas Day",
    "Christian",
    "All India",
    "Central gazetted holiday",
    "HIGH",
    "https://cgca.gov.in/ccapb/list-of-holiday"
  ],
  [
    "2026-12-25",
    "Good Governance Day / Atal Bihari Vajpayee Jayanti",
    "Civic",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ],
  [
    "2026-12-26",
    "Veer Bal Diwas",
    "Sikh / National",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://saiindia.gov.in/uploads/media/Restricted-Holidays-2026-0691596486a0f80-77797555.pdf"
  ],
  [
    "2026-12-31",
    "New Year's Eve",
    "Cultural",
    "All India",
    "Fixed",
    "MEDIUM",
    "https://www.india.gov.in/calendar"
  ]
];

export default master2026;
